import React from 'react'

import { makeAppStyles, MenuOption, Tab, Tabs } from '@percept/mui'


const useTabStyles = makeAppStyles( theme => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.text.hint}`,
  },
  tab: {
    textTransform: 'none',
  },
}))


type BasicSelectProps<T> = {
  value: T | null | undefined
  options: MenuOption<T>[]
  onChange: (value: T) => void
}


export function NavigationTabs<T>({
  value,
  options,
  onChange,
}: BasicSelectProps<T>): JSX.Element {
  const classes = useTabStyles()
  return (
    <Tabs
      indicatorColor='primary'
      textColor='primary'
      variant='fullWidth'
      className={classes.tabs}
      value={value}
      onChange={(_, value): void => {
        onChange(value)
      }}>
      {options.map( tab => (
        <Tab key={`tab-${tab.value}`} className={classes.tab} {...tab} />
      ))}
    </Tabs>
  )
}
